const LS_UNTIL = 'erp4c_break_until_ms';
const LS_PLANNED_SEC = 'erp4c_break_planned_seconds';
const LS_OVER_LOGGED = 'erp4c_break_overrun_logged';
const LS_PANEL_CLOSED = 'erp4c_break_panel_closed';
const LS_STARTED_AT = 'erp4c_break_started_at_ms';

export function setBreakSession({ untilMs, plannedSeconds, startedAtMs }) {
  try {
    localStorage.setItem(LS_UNTIL, String(untilMs));
    localStorage.setItem(LS_PLANNED_SEC, String(plannedSeconds));
    const start = startedAtMs != null && Number.isFinite(startedAtMs) ? startedAtMs : Date.now();
    localStorage.setItem(LS_STARTED_AT, String(start));
    localStorage.removeItem(LS_OVER_LOGGED);
    localStorage.removeItem(LS_PANEL_CLOSED);
  } catch {
    /* ignore */
  }
}

export function clearBreakSession() {
  try {
    localStorage.removeItem(LS_UNTIL);
    localStorage.removeItem(LS_PLANNED_SEC);
    localStorage.removeItem(LS_OVER_LOGGED);
    localStorage.removeItem(LS_PANEL_CLOSED);
    localStorage.removeItem(LS_STARTED_AT);
  } catch {
    /* ignore */
  }
}

export function getBreakUntilMs() {
  try {
    const v = localStorage.getItem(LS_UNTIL);
    if (v == null || v === '') return null;
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function getBreakPlannedSeconds() {
  try {
    const v = localStorage.getItem(LS_PLANNED_SEC);
    if (v == null || v === '') return null;
    const n = parseInt(v, 10);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function getBreakStartedAtMs() {
  try {
    const v = localStorage.getItem(LS_STARTED_AT);
    if (v == null || v === '') return null;
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

/** True while a timed break session exists (until punch-in clears storage). */
export function isBreakSessionActive() {
  return getBreakUntilMs() != null;
}

export function getBreakPanelClosed() {
  try {
    return localStorage.getItem(LS_PANEL_CLOSED) === '1';
  } catch {
    return false;
  }
}

export function setBreakPanelClosed(closed) {
  try {
    if (closed) localStorage.setItem(LS_PANEL_CLOSED, '1');
    else localStorage.removeItem(LS_PANEL_CLOSED);
  } catch {
    /* ignore */
  }
}

export function isBreakOverrunLogged() {
  try {
    return localStorage.getItem(LS_OVER_LOGGED) === '1';
  } catch {
    return false;
  }
}

export function markBreakOverrunLogged() {
  try {
    localStorage.setItem(LS_OVER_LOGGED, '1');
  } catch {
    /* ignore */
  }
}
